import type { ExperimentName } from "@glide/app-description";
import { getFeatureSetting } from "./feature-settings";

export function isExperimentEnabled(name: ExperimentName, userFeatures: Record<ExperimentName, boolean>): boolean {
    if (userFeatures[name]) return true;
    return getFeatureSetting(name);
}
